import http from "../../helpers/http";

import {
  FETCH_WHAT_IS_SEX_TRAFFIK_CONTENT_SUCCESS,
  FETCH_WHAT_IS_SEX_TRAFFIK_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("what-is-sex-trafficking")
    .then(({ data }) => {
      dispatch({
        type: FETCH_WHAT_IS_SEX_TRAFFIK_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_WHAT_IS_SEX_TRAFFIK_CONTENT_FAILED,
        payload: error
      });
    });
};
